export async function get<T>(url: string, throwError: boolean = false, aborter: AbortController | null = null) {
	const headers: HeadersInit = {
		"Content-Type": "application/json"
		// Authorization: "Bearer "
	};
	const opts: RequestInit = {
		method: "GET",
		headers: headers
	};

	if (aborter) {
		opts.signal = aborter.signal;
	}

	const responseData = await fetch(url, opts);

	if (!responseData.ok) {
		if (throwError) {
			throw new Error(responseData.statusText);
		}

		if (responseData.status !== 400) {
			return {
				errors: [{ message: "Unexpected error. Please refresh page and try again." }]
			};
		}
	}

	return responseData.json();
}

export async function post<T>(url: string, data: object, throwError: boolean = false) {
	const headers: HeadersInit = {
		"Content-Type": "application/json"
		// Authorization: "Bearer "
	};
	const opts: RequestInit = {
		method: "POST",
		headers: headers,
		body: JSON.stringify(data)
	};
	const responseData = await fetch(url, opts);

	if (!responseData.ok) {
		if (throwError) {
			throw new Error(responseData.statusText);
		}

		if (responseData.status !== 400) {
			return {
				errors: [{ message: "Unexpected error. Please refresh page and try again." }]
			};
		}
	}

	return responseData.json();
}
